import { Model } from '@vuex-orm/core';
import Zaui from '@/include/api';

export default class AvailabilityDay extends Model {
  static entity = 'availabilitydays';

  static fields() {
    return {
      id: this.attr(),
      count: this.number(),
      items: this.attr(),
      monthUnavailability: this.attr()
    };
  }

  static fetchMonth(month, category) {
    return Zaui.availability.month(month, category).then(data => {
      AvailabilityDay.insert({ data });
    });
  }

  static fetchDay(day, category, tempMonth = null) {
    return Zaui.availability.day(day, category, tempMonth).then(data => {
      AvailabilityDay.insert({ data });
    });    
  }
}